interface Props {
  value: string | number;
  label: string;
  accent?: boolean;
  onClick?: () => void;
}

export function MaStat({ value, label, accent = false, onClick }: Props) {
  const style: React.CSSProperties = {
    padding: "12px 14px",
    background: accent ? "var(--ma-ink)" : "var(--ma-cream)",
    color: accent ? "var(--ma-paper)" : "var(--ma-ink)",
    border: "var(--ma-border) solid var(--ma-ink)",
    borderRadius: "var(--ma-card-radius)",
    minWidth: 0,
    textAlign: "left",
    cursor: onClick ? "pointer" : "default",
    font: "inherit",
  };
  const inner = (
    <>
      <div className="ma-display" style={{ fontSize: 36, color: "inherit" }}>{value}</div>
      <div className="ma-mono" style={{
        fontSize: 9, letterSpacing: "0.14em",
        textTransform: "uppercase", color: "inherit", opacity: 0.7, marginTop: 4,
      }}>
        {label}
      </div>
    </>
  );
  if (onClick) {
    return <button onClick={onClick} style={style}>{inner}</button>;
  }
  return <div style={style}>{inner}</div>;
}
